module.exports = {
	filterstring: {
		type: String,
		default: '2personen:7nachten'
	}
};
